import React from 'react';
function CheckSelector({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M16 6L5 17l-3.5-3.5M21 8L11 18l-1-1" />
    </svg>
  );
}

export default CheckSelector;
